import Rect from '../../../fun-js-lib/geometry/Rect'
import { fillStyled, fillTextStyled, textWidth, textWidthFonted } from '../../canvasDraw'
import { textCram } from '../drawUtils'
import { mainFrameRect } from '../rects'
import { lineSpan, smallPadding, textPadding } from '../sizes'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function drawUpperLeftLines (context, linesColor) {
  let rect = upperLeftRect()

  labelTexts().forEach((text, i) => {
    let textW = textWidthFonted(context, font1(), text)
    let x = rect.x + smallPadding + textW + textPadding
    let y = rect.y + lineSpan * (i + 1)
    let width = strokeWidth(context, i)
    fillStyled(context, linesColor, () => {
      context.fillRect(x, y, width, 1)
    })
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 * @param {import('../../constructionLog').ConstructionLog} constructionLog 
 * @param {import('../../constructionLog').LogPage} page 
 */
export function textUpperLeft (context, linesColor, constructionLog, page) {
  let rect = upperLeftRect()
  let texts = [
    page.contractor_legal_entity_name,
    constructionLog.project_name,
    page.place
  ]
  labelTexts().forEach((text, i) => {
    let labelW = textWidth(context, text)
    let y = rect.y + lineSpan * (i + 1)
    fillTextStyled(context, text, rect.x + smallPadding, y, linesColor)
    textCram(context, texts[i],
      rect.x + smallPadding + labelW + textPadding, y, strokeWidth(context, i))
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {number} strokeI 
 */
function strokeWidth (context, strokeI) {
  let rect = upperLeftRect()
  let textW = textWidthFonted(context, font1(), labelTexts()[strokeI])
  return rect.w - textW - textPadding - smallPadding * 2
}

export function upperLeftRect () {
  let frame = mainFrameRect()
  return Rect.plain({
    x: frame.x,
    y: frame.y,
    w: 1000,
    h: 250
  })
}

function font1 () {
  return '30px Arial'
}

function labelTexts () {
  return ['ИЗВОЂАЧ РАДОВА', 'ОБJЕКАТ', 'МЕСТО']
}